var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#D83E38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8792 15.4489C22.4259 14.5475 23.3984 14 24.447 14C25.4957 14 26.4682 14.5475 27.0149 15.4489L35.493 29.6027C36.0261 30.5258 36.0292 31.6624 35.5014 32.5885C34.9735 33.5145 33.9939 34.091 32.917 34.1027L15.966 34.1027C14.9002 34.091 13.9205 33.5145 13.3927 32.5885C12.8648 31.6624 12.868 30.5258 13.4092 29.5889L21.8792 15.4489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4473 25.1028V21.1028C23.4473 20.5506 23.895 20.1028 24.4473 20.1028C24.9996 20.1028 25.4473 20.5506 25.4473 21.1028V25.1028C25.4473 25.6551 24.9996 26.1028 24.4473 26.1028C23.895 26.1028 23.4473 25.6551 23.4473 25.1028ZM25.1544 27.3957C25.5449 27.7863 25.5449 28.4194 25.1544 28.8099C24.7638 29.2005 24.1307 29.2005 23.7402 28.8099C23.3496 28.4194 23.3496 27.7863 23.7402 27.3957C24.1307 27.0052 24.7638 27.0052 25.1544 27.3957Z",
    fill: "#D83E38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.f9e40029513e7af492d0231dc5c7dae5.svg";
export { ForwardRef as ReactComponent };